@if (direction === 'back') {
  <kb-icon [icon]="icon ?? iconBack" />
}
<span>
  <ng-content />
</span>
@if (direction === 'forward') {
  <kb-icon [icon]="icon ?? iconForward" />
}
